import type { RefObject } from 'react';

/**
 * The spec's "Admin Interface" section, "A control never refuses in silence": a submit button is never switched off
 * because the reader has not finished filling the form in. Pressing it validates
 * *everything* — including fields that were never focused, which is exactly the empty-form
 * case that used to produce no feedback at all — marks each field at fault with its own
 * message, and moves focus to the first of them.
 *
 * This is the last half of that: hand it the fields in the order they appear on screen,
 * each with the error just computed for it, and it focuses the first one that has one.
 * Returns whether the form was at fault, so callers read as
 * `if (focusFirstInvalid(...)) return;`.
 */
export function focusFirstInvalid(
  fields: ReadonlyArray<{
    error: string | undefined;
    ref: RefObject<HTMLElement | null>;
  }>,
): boolean {
  const atFault = fields.find((field) => field.error !== undefined);
  if (!atFault) return false;
  atFault.ref.current?.focus();
  return true;
}
